import { render, staticRenderFns } from "./BaseNewsCard.vue?vue&type=template&id=0910d9d8&"
import script from "./BaseNewsCard.vue?vue&type=script&lang=js&"
export * from "./BaseNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseNewsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports